import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SidebarMenuItem } from 'components/molecules';
import { SidebarMenuProps, MenuItem } from 'types/components.types';

const SidebarMenu: React.FC<SidebarMenuProps> = ({
  onBackToLanding: _onBackToLanding,
  onNewClassification,
  menuItems,
  isCollapsed = false,
  className = ''
}) => {
  const navigate = useNavigate();

  // Default menu items if not provided
  const defaultMenuItems: MenuItem[] = [
    {
      id: 'new-classification',
      icon: 'edit',
      text: 'New Classification',
      shortcut: 'K',
      isActive: false,
      variant: 'primary',
      onClick: onNewClassification || (() => {})
    },
    {
      id: 'results',
      icon: 'list',
      text: 'Results',
      isActive: false,
      variant: 'default',
      onClick: () => navigate('/results')
    }
  ];

  const items = menuItems || defaultMenuItems;

  return (
    <nav className={`flex-none ${isCollapsed ? 'px-2' : 'px-4'} pt-6 flex flex-col gap-2 ${className}`}>
      {items.map((item) => (
        <SidebarMenuItem
          key={item.id}
          icon={item.icon}
          text={item.text}
          shortcut={item.shortcut}
          isActive={item.isActive}
          variant={item.variant}
          onClick={item.onClick}
          isCollapsed={isCollapsed}
        />
      ))}
    </nav>
  );
};

export default SidebarMenu;
